import { redirect } from "next/navigation";
import { FormState, SignupFormSchema } from "./definition";
import { BASE_URL } from "@/constants";

export async function signup(
  state: FormState,
  formData: FormData,
): Promise<FormState> {
  // 1. Validate form fields
  const validatedFields = SignupFormSchema.safeParse({
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    password: formData.get("password"),
  });

  // If any form fields are invalid, return early
  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
    };
  }

  // 2. Prepare data for insertion into database
  const { firstName, lastName, email, password } = validatedFields.data;
  const res = await fetch(BASE_URL + "user-auth/signup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ firstName, lastName, email, password }),
  });

  const data = await res.json();

  if (data.message) {
    return { error: data.message };
  } else {
    redirect(`/verification?email=${email}`);
  }
}